export const getIsLoadingScans = state => state.get('isLoading');

export const getScansStatusFilters = state => state.get('statusFilters');
export const getScansStatusFilter = (state, status) => state.getIn(['statusFilters', status]);

export const getScansSearch = state => state.get('search');
export const getScansSort = state => state.get('sort');
export const getIsSearchActive = state =>
  Boolean(state.getIn(['search', 'patientID']) || state.getIn(['search', 'scanNum']));
